export default __webpack_public_path__ + "static/media/audience.af32a8431267ba99052c6ac09b2494b0.svg";